export default __webpack_public_path__ + "static/media/research (1).b1567680.gif";